var _style, _g, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _g3, _g4, _defs2, _path11, _path12, _g5, _g6, _g7, _defs3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F6167;}\n\t.st1{clip-path:url(#SVGID_00000074404147132499364590000017395844976594712981_);enable-background:new    ;}\n\t.st2{fill:#435258;}\n\t.st3{fill:#374449;}\n\t.st4{fill:#8F9EA3;}\n\t.st5{fill:#6C8086;}\n\t.st6{fill:#313F44;}\n\t.st7{fill:#20292D;}\n\t.st8{clip-path:url(#SVGID_00000117668154161972570760000013316246861846981816_);enable-background:new    ;}\n\t.st9{fill:#4C5E64;}\n\t.st10{fill:#60767C;}\n\t.st11{fill:#55686D;}\n\t.st12{fill:#42545D;}\n\t.st13{clip-path:url(#SVGID_00000142139310258306211050000017969161689712107707_);enable-background:new    ;}\n\t.st14{fill:#2D393F;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.01,371.88c192.9,0,349.28,78.2,349.28,174.65c0,57.87-50.35,107.28-143.97,141.29l-205.3-141.29V371.88 z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M909.29,546.53v115.62c0,57.87-50.35,107.28-143.97,141.29V687.82 C858.94,653.81,909.29,604.4,909.29,546.53z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#435258"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039817168735835575290000010454376933566320826_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039817168735835575290000010454376933566320826_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M909.29,546.53v115.62c0,0.76-0.01,1.53-0.03,2.29V548.82C909.28,548.06,909.29,547.29,909.29,546.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M909.26,548.82v115.62c-0.13,5.52-0.71,10.95-1.76,16.31V565.12C908.55,559.77,909.13,554.33,909.26,548.82 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M907.51,565.12v115.62c-0.98,5.01-2.35,9.96-4.12,14.82V579.94C905.16,575.08,906.53,570.14,907.51,565.12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M903.39,579.94v115.62c-1.72,4.72-3.8,9.37-6.26,13.93V593.88C899.59,589.31,901.67,584.66,903.39,579.94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M897.13,593.88V709.5c-2.47,4.61-5.32,9.13-8.53,13.57V607.45C891.81,603.01,894.66,598.48,897.13,593.88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M888.6,607.45v115.62c-3.37,4.65-7.14,9.21-11.31,13.67V621.12C881.46,616.66,885.23,612.1,888.6,607.45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M877.29,621.12v115.62c-4.62,4.95-9.74,9.77-15.33,14.47V635.59C867.55,630.9,872.67,626.07,877.29,621.12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M861.96,635.59v115.62c-6.83,5.73-14.38,11.27-22.64,16.61V652.2 C847.58,646.87,855.13,641.33,861.96,635.59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M839.32,652.2v115.62c-14.15,9.15-30.38,17.69-48.61,25.56V677.76 C808.94,669.89,825.17,661.35,839.32,652.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M790.71,677.76v115.62c-8.08,3.49-16.54,6.84-25.4,10.06V687.82C774.17,684.61,782.64,681.25,790.71,677.76 "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "765.31,687.82 765.31,803.45 560.01,662.15 560.01,546.53  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.01,371.6v174.65l-107.95-166.1C488.76,374.19,521.42,371.6,560.01,371.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "560.01,546.25 560.01,661.87 452.06,495.78 452.06,380.15  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.06,380.36l107.95,166.1L227.8,492.49C263.58,437.45,341.97,398.24,452.06,380.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "560.01,546.46 560.01,662.08 227.8,608.12 227.8,492.49  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008832091638262729560000007578553970863570607_",
    d: "M209.95,663.96l0-115.62 c0,54.45,51.35,105.81,144.73,139.73v115.62C261.3,769.76,209.95,718.4,209.95,663.96z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008832091638262729560000007578553970863570607_",
    style: {
      overflow: "visible",
      fill: "#4C5E64"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027570869681439527830000006553052445210387336_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008832091638262729560000007578553970863570607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027570869681439527830000006553052445210387336_)",
      enableBackground: "new"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.68,688.07v115.62c-5.38-1.96-10.62-3.97-15.72-6.04V682.03C344.06,684.1,349.3,686.11,354.68,688.07"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M338.96,682.03v115.62c-83.41-33.82-129.01-82.39-129.01-133.7V548.33 C209.95,599.64,255.55,648.21,338.96,682.03"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.8,492.8l332.21,53.98L354.68,688.07C229.84,642.71,180.12,566.19,227.8,492.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "560.01,546.77 560.01,662.4 354.68,803.69 354.68,688.07  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M560.01,546.3l205.3,141.29c-62.42,22.68-133.86,34.02-205.31,34.02s-142.89-11.34-205.32-34.02 L560.01,546.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160869298265129087530000007492508929959102892_",
    d: "M765.31,687.6v115.62 c-62.42,22.68-133.86,34.02-205.31,34.02s-142.89-11.34-205.32-34.02V687.6c62.43,22.68,133.88,34.02,205.32,34.02 S702.89,710.28,765.31,687.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160869298265129087530000007492508929959102892_",
    style: {
      overflow: "visible",
      fill: "#2D393F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101073662136522091620000006088975833707430276_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160869298265129087530000007492508929959102892_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101073662136522091620000006088975833707430276_)",
      enableBackground: "new"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M765.31,687.6v115.62c-14.74,5.35-29.98,10.08-45.6,14.17V701.77 C735.34,697.68,750.58,692.95,765.31,687.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M719.71,701.77v115.62c-20.96,5.49-42.6,9.84-64.66,13.05V714.81 C677.11,711.6,698.76,707.25,719.71,701.77"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M655.06,714.81v115.62c-13.22,1.93-26.59,3.44-40.05,4.55V719.37 C628.47,718.26,641.83,716.74,655.06,714.81"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M615.01,719.37v115.62c-11.1,0.91-22.26,1.55-33.45,1.91V721.27 C592.75,720.92,603.91,720.28,615.01,719.37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M581.57,721.27V836.9c-7.18,0.23-14.37,0.34-21.56,0.34c-2.88,0-5.77-0.02-8.65-0.06V721.56 c2.88,0.04,5.77,0.06,8.65,0.06C567.2,721.62,574.39,721.5,581.57,721.27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M551.36,721.56v115.62c-9.51-0.12-19.02-0.45-28.5-0.97V720.59C532.34,721.12,541.84,721.44,551.36,721.56 "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M522.86,720.59v115.62c-9.27-0.51-18.52-1.22-27.72-2.12V718.48 C504.34,719.38,513.58,720.08,522.86,720.59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M495.14,718.48V834.1c-9.24-0.9-18.43-2-27.56-3.29V715.19C476.71,716.48,485.9,717.58,495.14,718.48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M467.58,715.19v115.62c-9.44-1.33-18.81-2.88-28.09-4.63V710.56 C448.77,712.31,458.14,713.86,467.58,715.19"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M439.49,710.56v115.62c-9.95-1.88-19.79-3.99-29.5-6.35V704.21C419.7,706.57,429.54,708.69,439.49,710.56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M409.99,704.21v115.62c-10.99-2.67-21.81-5.64-32.41-8.92V695.29C388.18,698.57,399,701.54,409.99,704.21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M377.58,695.29v115.62c-7.75-2.4-15.39-4.96-22.9-7.69V687.6C362.19,690.33,369.83,692.89,377.58,695.29"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.4038c2f4213854f01858acf5af233942.svg";
export { ForwardRef as ReactComponent };